import { render, staticRenderFns } from "./cpfCnpj-input.vue?vue&type=template&id=4868e1b8&scoped=true"
import script from "./cpfCnpj-input.vue?vue&type=script&lang=js"
export * from "./cpfCnpj-input.vue?vue&type=script&lang=js"
import style0 from "./cpfCnpj-input.vue?vue&type=style&index=0&id=4868e1b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4868e1b8",
  null
  
)

export default component.exports